import React, { StatelessComponent } from "react";

interface InputFieldProps {
    label: string;
    className: string;
    name: string;
    id: string;
    onChange?: Function;
    isDisabled?: boolean;
    onBlur?: () => void;
    onKeyUp?: Function;
    isValidationError?: boolean;
    validationErrorMessage?: string;
    isRequestError?: boolean;
    requestErrorMessage?: string;
}

const InputField: StatelessComponent<InputFieldProps> = (props: InputFieldProps) => {
    const {label, className, name, id, isDisabled: disabled,
        isRequestError, isValidationError, validationErrorMessage, requestErrorMessage} = props;

    return (
    <div className="field-spacing">
        <label className="fieldLabel">
            {label}
        </label>
        <input className={className}
            id={id}
            name={name}
            type="text"
            onChange={(e) => { props.onChange(e) }}
            disabled={disabled}
            onBlur={props.onBlur}
            onKeyUp={(e) => { props.onKeyUp(e) }}
        />
        {isValidationError &&
            <span className="field-validation-error">
                <span>{validationErrorMessage}</span>
            </span>
        }
        {isRequestError &&
            <span className="field-validation-error">
                <span>{requestErrorMessage}</span>
            </span>}
    </div>
    );
}

export default InputField;